import checkItemType from "./checkItemType";


const ItemSizeName = (item: any) => {
  if (checkItemType(item) == 3) {
    return "";
  } else {
    const name = item?.selected_variation?.variation_detail?.[0]?.variation_name || ""
    if (name) {
      return `(${item?.selected_variation?.variation_detail?.[0]?.variation_name || ""})`
    } else {
      return '';
    }
  }
};


export const ItemSizeVariationName = (item: any) => {
  const name = item?.item_variation?.variation_name || "";
  if (name) {
    return `(${name})`;
  } else {
    return ''
  }

}

export const ItemSizeNameForOrder = (item: any) => {
  if (checkItemType(item) == 3) {
    return "";
  } else {
    const name = item?.selected_variation?.[0]?.variation_detail?.[0]?.variation_name || ""
    // console.log('itemitassemitemitem', item, name)
    if (name) {
      return `(${name})`
    } else {
      return '';
    }
  }
}

export default ItemSizeName;
